import { IGrupoProduto } from "../../../Interfaces/Geral/Grupos/GrupoProdutoInterfaces";
import {
    DesvincularProdutoGrupoService,
    ListarProdutosDesvinculadosPorGrupoService,
    ListarProdutosVinculadosPorGrupoService,
    VincularProdutoGrupoService,
} from "../../../Services/Geral/Grupos/GruposProdutoServices";
import { Controller } from "../../Controller";

export const ListarProdutosVinculadosPorGrupoController = (idGrupo: number) =>
    Controller(ListarProdutosVinculadosPorGrupoService(idGrupo));

export const ListarProdutosDesvinculadosPorGrupoController = (
    idGrupo: number
) => Controller(ListarProdutosDesvinculadosPorGrupoService(idGrupo));

export const VincularProdutoGrupoController = (grupoProduto: IGrupoProduto[]) =>
    Controller(VincularProdutoGrupoService(grupoProduto));

export const DesvincularProdutoGrupoController = (idProdutoGrupo: number[]) =>
    Controller(DesvincularProdutoGrupoService(idProdutoGrupo));
